import { render } from "./StartEncounterComponent.vue?vue&type=template&id=05b45d7b&scoped=true"
import script from "./StartEncounterComponent.vue?vue&type=script&lang=js"
export * from "./StartEncounterComponent.vue?vue&type=script&lang=js"

import "./StartEncounterComponent.vue?vue&type=style&index=0&id=05b45d7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b45d7b"]])

export default __exports__